import { ReactNode } from 'react'

export const breakText = (text: string | ReactNode = '') => {
  return (text as string)
    .split('\n')
    .reduce(
      (acc, textPart, index) => {
        return [...acc, textPart, <br key={`br-${index}`} />]
      },
      [] as (string | ReactNode)[],
    )
    .slice(0, -1)
}
